export const initialState = {
  tags: []
}

export const productTagReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_TAG':
      return {
        ...state,
        tags: state.tags.concat([action.value])
      }
    case 'DELETE_TAG':
      return {
        ...state,
        tags: state.tags.filter((option) => option.tag_id !== action.value)
      }
    case 'SET_TAG':
      return {
        ...state,
        tags: action.value
      }
    default:
      throw new Error(`${action.type}을 찾을 수 없습니다.`);
  }
}